import React from "react";
import styled from "styled-components";

import { TransactionErrorIcon } from "../../../common/svg/transaction-error-icon";
import { TransactionValidateIcon } from "../../../common/svg/transaction-validate-icon";

const PENDING_COLOR = "#741537";
const DONE_COLOR = "#0b293e";

interface TransactionStateTagProps {
  label: string;
  done: boolean;
}

/** Small pill showing whether a transaction is justified / qualified. */
export function TransactionStateTag({ label, done }: Readonly<TransactionStateTagProps>) {
  return (
    <Pill $done={done}>
      {done ? (
        <TransactionValidateIcon width={14} height={14} fill={DONE_COLOR} />
      ) : (
        <TransactionErrorIcon width={12} height={12} fill={PENDING_COLOR} />
      )}
      <Label $done={done}>{label}</Label>
    </Pill>
  );
}

/* Mauve flags what is still pending, neutral grey what is done. */
const Pill = styled.span<{ $done: boolean }>`
  display: inline-flex;
  align-items: center;
  background-color: ${(props) => (props.$done ? "#f7f8ff" : "#f1e7eb")};
  border-radius: 3px;
  padding: 5px 10px;
`;

const Label = styled.span<{ $done: boolean }>`
  margin-left: 6px;
  font-size: 12px;
  color: ${(props) => (props.$done ? DONE_COLOR : PENDING_COLOR)};
`;
